import { render, staticRenderFns } from "./LogPlayerIncident.vue?vue&type=template&id=4ab9d454"
import script from "./LogPlayerIncident.vue?vue&type=script&lang=js"
export * from "./LogPlayerIncident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports